module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "pl10px pr10px",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("服务卡号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.vehicleAccount),
      expression: "vehicleInfo.vehicleAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehicleAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehicleAccount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_right"
  }, [_vm._v("服务起始日")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.serviceStartTime),
      expression: "vehicleInfo.serviceStartTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.serviceStartTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "serviceStartTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("服务结束日")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.serviceEndTime),
      expression: "vehicleInfo.serviceEndTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.serviceEndTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "serviceEndTime", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车辆品牌")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.isRender) ? _c('select2', {
    attrs: {
      "options": _vm.vehicleBrands
    },
    model: {
      value: (_vm.vehicleInfo.brandId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleInfo, "brandId", $$v)
      },
      expression: "vehicleInfo.brandId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车系")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.serialId),
      expression: "vehicleInfo.serialId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "serialId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleSerials), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.serialName) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.modelId),
      expression: "vehicleInfo.modelId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "modelId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleModels), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.modelName) + "\n\t\t\t\t\t")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("变速器")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.transmission),
      expression: "vehicleInfo.transmission"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "transmission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleTransmission), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("排量(升)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.vehicleInfo.displacement),
      expression: "vehicleInfo.displacement",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.displacement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "displacement", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("颜色")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.color),
      expression: "vehicleInfo.color"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleColor), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("座位")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.seat),
      expression: "vehicleInfo.seat"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "seat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleSeat), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("款型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.style),
      expression: "vehicleInfo.style"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "style", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleStyle), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("燃油类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.fuelType),
      expression: "vehicleInfo.fuelType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "fuelType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleFueltype), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("平均油耗")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.avgOil),
      expression: "vehicleInfo.avgOil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.avgOil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "avgOil", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车辆短备注")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.vehicleInfo.vehicleNum),
      expression: "vehicleInfo.vehicleNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehicleNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehicleNum", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车牌号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('vplate-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.vehicleInfo.plateNumber),
      callback: function($$v) {
        _vm.$set(_vm.vehicleInfo, "plateNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "vehicleInfo.plateNumber"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车辆登记日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.startSaleTime),
      expression: "vehicleInfo.startSaleTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.startSaleTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "startSaleTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("VIN/车架号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.frameNo),
      expression: "vehicleInfo.frameNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.frameNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "frameNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("发动机号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.engineNumber),
      expression: "vehicleInfo.engineNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.engineNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "engineNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("销售日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.startSaleTime),
      expression: "vehicleInfo.startSaleTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.startSaleTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "startSaleTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("销售顾问")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.saler),
      expression: "vehicleInfo.saler"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.saler)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "saler", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("新车购价")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.vehiclePrice),
      expression: "vehicleInfo.vehiclePrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehiclePrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehiclePrice", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.memo),
      expression: "vehicleInfo.memo"
    }],
    staticClass: "col-sm-11",
    attrs: {
      "rows": "6",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.vehicleInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "memo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group t_center"
  }, [(_vm.permission.indexOf('fileCarList_baseInfoSave') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.ensureSave
    }
  }, [_vm._v("保存基本信息")]) : _vm._e()])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d7ba84","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didicarfile/detail/DetailBasic.vue
// module id = 1400
// module chunks = 0